import React  from 'react'

import './schoolOverview.css'


const assessmentMap = {
    3: 'ENT',
    4: 'EYE',
    5: 'PHYISCAL',
    6: 'DENTAL',

}


const SchoolOverViewComponent = (props) => {

    const health = props.reportData.health
    const growth = props.reportData.growth
    const gender = props.reportData.gender 
    const hygiene = props.reportData.hygiene 
    const classData = props.reportData.class
    
    return (
        <div className="hsg-school-overview-html">
            <section className="hsg-content pr-hsg-content">
                <div className="container-fluid">
                    
                    <div className="row">
                        <div className="col-sm-12">
                        <div className="hsg_overview">
                            <div className="overview__col overview__left">
                            <h4 className="overview__title dashboard_title semibold">School Health Overview</h4>
                            </div>
                            <div className="overview__col overview__right quote__right hidden-xs">
                            <p className="overview__quote thin">All HealthSetGo assessments are benchmarked with the Indian Academy of Pediatrics Growth Standards for Children (IAP) and the World Health Organizations (WHO) growth charts.</p>
                            </div>
                        </div> 
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 sep1">
                            <h4 className="dashboard_title underline semibold">1. BMI Analysis</h4>
                            <div className="row table_bmiAnalysis">
                                <div className="col-xs-6 col-sm-3 col__bmi">
                                <div className="col__inner">
                                    <img className="bmi_analysis_img" src="img/bmi_under.png"/>
                                </div>
                                <span className="bmi__value">{`${growth && growth.underweight || "0%"}`}</span>
                                <span className="bmi__status">Underweight</span>
                                </div>
                                <div className="col-xs-6 col-sm-3 col__bmi">
                                <div className="col__inner">
                                    <img className="bmi_analysis_img" src="img/bmi_normal.png"/>
                                </div>
                                <span className="bmi__value">{`${growth && growth.normal || "0%"}`}</span>
                                <span className="bmi__status">Normal</span>
                                </div>
                                <div className="col-xs-6 col-sm-3 col__bmi">
                                <div className="col__inner">
                                    <img className="bmi_analysis_img" src="img/bmi_over.png"/>
                                </div>
                                <span className="bmi__value">{`${growth && growth.overweight || "0%"}`}</span>
                                <span className="bmi__status">Overweight</span>
                                </div>
                                <div className="col-xs-6 col-sm-3 col__bmi">
                                <div className="col__inner">
                                    <img className="bmi_analysis_img" src="img/bmi_obese.png"/>
                                </div>
                                <span className="bmi__value">{`${growth && growth.obese || "0%"}`}</span>
                                <span className="bmi__status">Obese</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <h4 className="dashboard_title underline semibold">2. Hygiene Analysis</h4>
                            <div className="row table_hygieneAnalysis">
                                <div className="col-xs-6 col__hygiene">
                                <div className="hygiene__status normal">
                                    <span className="hygiene__value">{`${hygiene && hygiene.hygiene ? 100 - parseInt(hygiene.hygiene, 10) : '100'}%`}</span>
                                    <span className="hygiene__text">Good</span>
                                </div>
                                </div>
                                <div className="col-xs-6 col__hygiene">
                                <div className="hygiene__status attention">
                                    <span className="hygiene__value">{`${hygiene && hygiene.hygiene || "0%"}`}</span>
                                    <span className="hygiene__text">Needs Attention</span>
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>

                   
                    <div className="row table_healthIndicators">
                        <div className="col-sm-12"><h4 className="dashboard_title underline semibold">3. School Health Indicators</h4></div>

                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-md-6 col__healthIndi">
                                    <img className="healthIndi_icon" src="img/health_indi_1.png" />
                                        <div className="healthIndi__details ">
                                            <h5 className="semibold">Best Performing Assessment</h5>
                                            <h5 className="text-muted semibold">{health && health.high_performing_assessment ? assessmentMap[health.high_performing_assessment] : ''}</h5>
                                            <br/>
                                            <h5 className="semibold">Healthiest parameter</h5>
                                            <h5 className="text-muted semibold" >{health && health.high_performing_in_assessment }</h5>
                                        </div>
                                </div>
                                <div className="col-md-6 col__healthIndi sep2">
                                    <img className="healthIndi_icon" src="img/health_indi_2.png" />
                                    <div className="healthIndi__details">
                                        <h5 className="semibold">Low Performing Assessment</h5>
                                        <h5 className="text-muted semibold">{health && health.low_performing_assessment ? assessmentMap[health.low_performing_assessment] : ''}</h5>
                                        <br/>
                                        <h5 className="semibold"> Area Of Concern</h5>
                                        <h5 className="text-muted semibold">{health && health.low_performing_in_assessment}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div className="row">
                        <div className="col-lg-4">
                            <h4 className="dashboard_title underline semibold">4. Class Overview</h4>
                            <table className="table table_classOverview">
                                <tbody>
                                <tr>
                                    <td colSpan="2">
                                    <img src="img/class_overview_1.png"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="col__classOverview">
                                    <img style={{width: "223px"}} src="img/class_overview_2.png"/>
                                        <h5 className="semibold">Healthiest Class</h5>
                                        <h5 className="normal semibold">{classData && classData.high_performing_class}</h5>
                                        <br/>
                                        <h5 className="semibold">Best Assessment</h5>
                                        <h5 className="normal semibold">{ classData && classData.high_performing_assessment_in_class ? assessmentMap[classData.high_performing_assessment_in_class] : ''}  </h5>
                                
                                    </td>
                                    <td className="col__classOverview">
                                    <img src="img/class_overview_3.png" />
                                    <h5 className="semibold">Unhealthiest Class</h5>
                                    <h5 className="attention semibold">{classData && classData.low_performing_class}</h5>
                                    <br/>
                                    <h5 className="semibold">Low Performing Assessment</h5>
                                    
                                    <h5 className="attention semibold">{classData && classData.low_performing_assessment_in_class ? assessmentMap[classData.low_performing_assessment_in_class] : ''}</h5>
                                
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-lg-8 sep3">
                            <h4 className="dashboard_title underline semibold">5. Gender Analysis</h4>
                            <div className="row table_genderAnalysis">
                                <div className="col-md-5 col__gender male">
                                    <div className="col__inner">
                                        <div className="container_imgGender male">
                                            <span className="gender__totalCount">{`Male(${gender && gender.male_students_count || 0})`}</span>
                                            <img className="img__gender" src="img/gender_male.png"/>
                                        </div>
                                        <div className="gender__assessment male normal">
                                            <span className="assessment__value">{gender && gender.m ? 100 - parseInt(gender.m, 10) : '100'}%</span>
                                            <span className="assessment_text">Normal</span>
                                        </div>
                                        <div className="gender__assessment male attention">
                                            <span className="assessment__value">{gender && gender.m}</span>
                                            <span className="assessment_text">Needs Attention</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-7 col__gender female">
                                    <div className="col__inner">
                                        <div className="gender__assessment female attention">
                                            <span className="assessment__value">{gender && gender.f}</span>
                                            <span className="assessment_text">Needs Attention</span>
                                        </div>
                                        <div className="container_imgGender female">
                                            <span className="gender__totalCount">{`Female(${gender && gender.female_students_count || 0})`}</span>
                                            <img className="img__gender" src="img/gender_female.png"/>
                                        </div>
                                        <div className="gender__assessment female normal">
                                            <span className="assessment__value">{gender && gender.f ? 100 - parseInt(gender.f, 10) : '100'}%</span>
                                            <span className="assessment_text">Normal</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </div>
    )

}

export default SchoolOverViewComponent


// WEBPACK FOOTER //
// ./src/Containers/DashboardContainer/Component/SchoolOverViewComponent.js